module.exports = __webpack_public_path__ + "media/images/boca-a365d8f8f8bd818b4dcc260d4287c130.png";